import { useConfigContext } from "@voxmedia/duet-context/context/config-context";
import { getCoralIdFromNode } from "@voxmedia/duet-utils";
import { useCoralPreviewOverride } from "src/context/CoralPreviewOverrideContext";

/** CSK coral story ID resolution (includes `?comments=test` preview override). */
export function useCskCoralStoryId(args: {
  chorusId?: number | null;
  chorusUuid?: string | null;
  globalId?: string | null;
  nodeId?: string;
}): string {
  const { coralConfig } = useConfigContext();
  const storyIdOverride = useCoralPreviewOverride()?.storyId;

  if (!coralConfig) {
    throw new Error("missing coral config");
  }

  if (storyIdOverride) {
    return storyIdOverride;
  }

  return getCoralIdFromNode(args);
}
